














































































import {Vue, Component, Prop} from 'vue-property-decorator';
import aboutMe from './about-me';

@Component
export default class AboutPortrait extends Vue {
  @Prop({default: 'all'}) private filterBy: string;

  private aboutMe = aboutMe;

  private filters = ['all', 'tech', 'finance', 'education', 'math', 'health'];

  private liked = false;
  private likes = 99;

  private toggleLike() {
    this.liked = !this.liked;
    this.liked ? this.likes++ : this.likes--;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/about/portrait/portrait.vue